module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col group_3"
  }, [_c('div', {
    staticClass: "flex-col section_1"
  }, [_c('div', {
    staticClass: "flex-col group_4"
  }, [_c('img', {
    attrs: {
      "src": "https://imgpub1.shouqiev.com/gofunplatform/files/20220815/XblryVsvYA.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_3"
  }, [_vm._v("预定成功")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v(_vm._s(_vm.desc))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-col items-center button_1",
    on: {
      "click": _vm.goback
    }
  }, [_c('span', {
    staticClass: "text_8"
  }, [_vm._v("我知道了")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col items-end button"
  }, [_c('div', {
    staticClass: "group_5"
  }, [_c('span', {
    staticClass: "text_5"
  }, [_vm._v("您可在")]), _vm._v(" "), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("GoFun优选 - 购买记录")]), _vm._v(" "), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("查看您的订单")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7c2ab3de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7c2ab3de","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/pay/paySucc.vue
// module id = 282
// module chunks = 320 321